import { useSceneStore, useTemporalStore } from "../store/sceneStore";
import type { TransformMode, ViewPreset } from "../types";

interface Props {
  onView: (preset: ViewPreset) => void;
}

export function Toolbar({ onView }: Props) {
  const interactionMode = useSceneStore((s) => s.interactionMode);
  const setInteractionMode = useSceneStore((s) => s.setInteractionMode);
  const transformMode = useSceneStore((s) => s.transformMode);
  const setTransformMode = useSceneStore((s) => s.setTransformMode);
  const settings = useSceneStore((s) => s.settings);
  const toggleGround = useSceneStore((s) => s.toggleGround);
  const toggleGrid = useSceneStore((s) => s.toggleGrid);
  const toggleAutoRotate = useSceneStore((s) => s.toggleAutoRotate);
  const selectedId = useSceneStore((s) => s.selectedId);

  const undo = useTemporalStore((s) => s.undo);
  const redo = useTemporalStore((s) => s.redo);
  const pastLength = useTemporalStore((s) => s.pastStates.length);
  const futureLength = useTemporalStore((s) => s.futureStates.length);

  const transformButtons: { mode: TransformMode; label: string }[] = [
    { mode: "translate", label: "⇄ Verschieben" },
    { mode: "rotate", label: "↻ Drehen" },
    { mode: "scale", label: "⤢ Skalieren" },
  ];

  return (
    <div className="toolbar">
      <div className="toolbar-group">
        <button className={interactionMode === "select" ? "active" : ""} onClick={() => setInteractionMode("select")}>
          Auswahl
        </button>
        <button className={interactionMode === "measure" ? "active" : ""} onClick={() => setInteractionMode("measure")}>
          📏 Messen
        </button>
      </div>

      {interactionMode === "select" && (
        <div className="toolbar-group">
          {transformButtons.map(({ mode, label }) => (
            <button
              key={mode}
              className={transformMode === mode ? "active" : ""}
              disabled={!selectedId}
              onClick={() => setTransformMode(mode)}
            >
              {label}
            </button>
          ))}
        </div>
      )}

      <div className="toolbar-group">
        <button onClick={() => onView("front")}>Front</button>
        <button onClick={() => onView("top")}>Oben</button>
        <button onClick={() => onView("iso")}>Iso</button>
      </div>

      <div className="toolbar-group">
        <button className={settings.groundVisible ? "active" : ""} onClick={toggleGround}>
          Boden
        </button>
        <button className={settings.gridVisible ? "active" : ""} onClick={toggleGrid}>
          Gitter
        </button>
        <button className={settings.autoRotate ? "active" : ""} onClick={toggleAutoRotate}>
          ↻ Dreh
        </button>
      </div>

      <div className="toolbar-group">
        <button disabled={pastLength === 0} onClick={() => undo()}>
          ⤺ Undo
        </button>
        <button disabled={futureLength === 0} onClick={() => redo()}>
          ⤻ Redo
        </button>
      </div>
    </div>
  );
}
